import { useEffect ,useState }                    from 'react'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import PrivateRoute     from './PrivateRoute'
import { AuthContext }  from './context/auth';
import AuthService      from './common/AuthService';
import Main             from './components/Main';
import Login            from './components/profile/Login';
import NoMatch403       from './components/NoMatch403';
import NoMatch404       from './components/NoMatch404';
import config           from './config';
import                       './css/App.css';
import CommonUtilities  from './common/CommonUtilities';

function App() {
    
    const
         bDebug             = !!config?.DEBUG?.App
        ,existingTokens     = ( localStorage.getItem("token")      !== 'undefined' ) ? ( localStorage.getItem('token')      ?? '' ) : ''
        ,existingPrivileges = ( localStorage.getItem("privileges") !== 'undefined' ) ? ( localStorage.getItem('privileges') ?? '' ) : '' // "{\"FLAG_ADMIN\":\"Y\"}" // stringa JSON
        ,existingKUser      = ( localStorage.getItem("kUser")      !== 'undefined' ) ? ( localStorage.getItem('kUser')      ?? '' ) : ''
        ,existingName       = ( localStorage.getItem("fullname")   !== 'undefined' ) ? ( localStorage.getItem('fullname')   ?? '' ) : ''
        
        ,[ authToken,      setAuthToken      ] = useState(existingTokens)
        ,[ authPrivileges, setAuthPrivileges ] = useState(existingPrivileges) // "{\"FLAG_ADMIN\":\"Y\"}" // stringa JSON
        ,[ authKUser,      setAuthKUser      ] = useState(existingKUser)
        ,[ authFullName,   setAuthFullName   ] = useState(existingName)
    ;
    
    /**
     * Gestisce e memorizza i token di autenticazione dell'utente.
     *
     * @description
     * Accetta in input un oggetto contenente i dati dell'utente autenticato,
     * li memorizza in localstorage (dentro a AuthService)
     * e li salva nei relativi stati in questo componente (App). 
     * Se l'oggetto è vuoto o non valido, pulisce tutti i token.
     *
     * @param {Object} oUserData - Oggetto contenente i dati dell'utente
     * @param {string} [oUserData.token] - Token di autenticazione
     * @param {string} [oUserData.kUser] - Identificativo univoco dell'utente
     * @param {string} [oUserData.username] - Nome utente
     * @param {string} [oUserData.fullname] - Nome completo dell'utente
     * @param {string} [oUserData.privileges] - Stringa JSON contenente i privilegi dell'utente
     *
     * @returns {void} - La funzione non ritorna alcun valore
     *
     * @example
     * 
     * // Impostazione dei token con dati utente validi
     * setTokens({
     *    token:      'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9...'
     *   ,kUser:      '12345'
     *   ,username:   'mario.rossi'
     *   ,fullname:   'Mario Rossi'
     *   ,privileges: '{"FLAG_ADMIN":"Y"}'
     * });
     *
     * // Pulizia dei token
     * setTokens(null);
     */
    const setTokens = ( oUserData ) => {
        
        if ( !oUserData || (
                ( ( typeof oUserData ) === 'object' ) 
                && ( Object.keys(oUserData).length === 0 )
            )
        ) {
            bDebug && console.warn('App.js - setTokens: no oUserData');
            setAuthToken(       '');
            setAuthPrivileges(  '');
            setAuthKUser(       '');
            setAuthFullName(    '');
            return;
        }
        
        bDebug && console.warn('App.js - setTokens: oUserData OK');
        /* oUserData = {
             token
            ,kUser
            ,username
            ,fullname
            ,privileges
        } */
        
        // Usa AuthService per memorizzare i dati
        AuthService.storeUserData(oUserData); // in setTokens
        
        setAuthToken(      oUserData.token       || '' );
        setAuthPrivileges( oUserData.privileges  || '' ); // "{\"FLAG_ADMIN\":\"Y\"}" // stringa JSON
        setAuthKUser(      oUserData.kUser       || '' );
        setAuthFullName(   oUserData.fullname    || '' );
        
    }
    
    const truncateToken = CommonUtilities.truncateToken;
    
    useEffect( () => {
        bDebug && console.log('App > stato authToken corrente: "' + truncateToken( authToken, 15 ) + '"');
    } ,[authToken]);
    
    return (
        <AuthContext.Provider value={{ authToken, setTokens, authPrivileges, authKUser, authFullName }}>
            <Router>
                <Switch>
                    
                    <PrivateRoute exact path="/"                        component={Main} />
                    <PrivateRoute exact path="/dashboard"               component={Main} />
                    <PrivateRoute exact path="/settings/user-groups"    component={Main} />
                    <PrivateRoute exact path="/settings/cubes-settings" component={Main} />
                    <PrivateRoute exact path="/settings/users-settings" component={Main} />
                    <PrivateRoute exact path="/settings/users-editing"  component={Main} />
                    <PrivateRoute       path="/cubes/"                  component={Main} />
                    <PrivateRoute exact path="/change-password"         component={Main} />
                    <PrivateRoute exact path="/impersonate-user"        component={Main} />
                    
                    <Route        exact path="/login"                   component={Login}/>
                    
                    <Route        exact path="/403"                     component={NoMatch403} />
                    <Route                                              component={NoMatch404} />
                
                </Switch>
            </Router>
        </AuthContext.Provider>
    );
}


export default App;
